import { render, staticRenderFns } from "./unBindWx.vue?vue&type=template&id=0f47f5db&scoped=true"
import script from "./unBindWx.vue?vue&type=script&lang=ts"
export * from "./unBindWx.vue?vue&type=script&lang=ts"
import style0 from "./unBindWx.vue?vue&type=style&index=0&id=0f47f5db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47f5db",
  null
  
)

export default component.exports